import React, { Component } from 'react'
import './HtmlEditor.scss'
import $ from 'jquery'
import jQuery from 'jquery'
import 'froala-editor/js/froala_editor.pkgd.min.js'
import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'font-awesome/css/font-awesome.css'
import FroalaEditor from 'react-froala-wysiwyg'

class HtmlEditor extends Component {
    render() {
        const S3ConfigImage = {
            bucket: 'hausplanner',
            region: 's3.ap-northeast-2',
            keyStart: 'temp/froala/image/',
            params: {
                acl: 'public-read',
                accessKey: 'AKIAJCVQJVNQI5YKBIEA',
                secretKey: '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',
            },
        }

        const S3ConfigFile = {
            bucket: 'hausplanner',
            region: 's3.ap-northeast-2',
            keyStart: 'temp/froala/file/',
            params: {
                acl: 'public-read',
                accessKey: 'AKIAJCVQJVNQI5YKBIEA',
                secretKey: 'j+JIu6RtvRQ88OEhPzQjkdzIAgoPkNpE4pImBz4m',
            },
        }

        const config = {
            placeholderText: '내용을 입력하세요',
            key: 'AA16A7C3D5A2C3A2H-9C1A8B5B1A8B1F2E5A4B3nB-33ud1egtxtuyoD5B-13ol==',
            imageUploadToS3: S3ConfigImage,
            fileUploadToS3: S3ConfigFile,
            toolbarButtons: [
                'bold',
                'italic',
                'underline',
                'fontSize',
                'color',
                'paragraphFormat',
                'align',
                'formatOL',
                'formatUL',
                'insertLink',
                'insertImage',
                'undo',
                'redo',
            ],
        }

        return (
            <div className="editor_wrap">
                <FroalaEditor
                    config={config}
                    tag="textarea"
                    model={this.props.content}
                    onModelChange={this.props.handleModelChange}
                />
            </div>
        )
    }
}

export default HtmlEditor



// WEBPACK FOOTER //
// ./Src/Components/Commons/HtmlEditor.js